export default __webpack_public_path__ + "static/media/ydzx.35cd01f2.png";